<administrasjon-navigasjon aktiv="spoerreskjemaer">
    @if (erIRedigering()) {
        <spoerreskjema-rediger [spoerreskjema]="redigertSkjema()" (vedFerdig)="vedRedigeringFerdig()"/>
    } @else {
        <div class="handlinger">
            <button mat-raised-button color="primary" type="button" (click)="nyttSkjema()" data-testid="nytt-skjema-knapp">
                {{ 'Nytt spørreskjema' | translate }}
            </button>
        </div>

        <div class="liste std-max-innholdsbredde">
            @for (skjema of skjemaer(); track skjema.id) {
                <article class="skjema" [class.deaktivert]="skjema.deaktivert" data-testid="spoerreskjema">
                    <div class="rad">
                        <button mat-icon-button type="button" class="ekspander" [class.ekspandert]="erEkspandert(skjema)"
                                (click)="vekslForhaandsvisning(skjema)"
                                [attr.aria-expanded]="erEkspandert(skjema)"
                                [attr.aria-label]="ekspanderTekst(skjema) | translate"
                                [matTooltip]="ekspanderTekst(skjema) | translate"
                                data-testid="ekspander-knapp">
                            <mat-icon fontSet="ion-ios-arrow-right" class="mat-icon--ionic-ikon"/>
                        </button>
                        <div class="innhold">
                            <div class="tittel">
                                {{ skjema.tittel }}
                                @if (skjema.deaktivert) {
                                    <span class="deaktivert-merke" [matTooltip]="'Skjemaet kan ikke benyttes i nye undersøkelser' | translate" data-testid="deaktivert">{{ 'Deaktivert' | translate }}</span>
                                }
                            </div>
                            <html-formatert class="beskrivelse" [innhold]="skjema.beskrivelse" trunker="200"/>
                            <div class="metainfo">
                                {{ '{antall} spørsmål' | translate: {antall: antallSpoersmaal(skjema)} }}
                                @if (skjema.avtaler.length > 0) {
                                    · <span class="avtaler" data-testid="avtaler">{{ 'Kun for: {avtaler}' | translate: {avtaler: avtalenavn(skjema)} }}</span>
                                }
                                @if (erIBruk(skjema)) {
                                    · <span class="i-bruk" data-testid="i-bruk">{{ 'I bruk i {antall} undersøkelser' | translate: {antall: skjema.antallUndersoekelser} }}</span>
                                }
                            </div>
                        </div>
                        <div class="skjemahandlinger">
                            <button mat-stroked-button type="button" (click)="rediger(skjema)" data-testid="rediger-knapp">{{ 'Rediger' | translate }}</button>
                            <button mat-stroked-button type="button" (click)="kopier(skjema)" data-testid="kopier-knapp">{{ 'Kopier' | translate }}</button>
                            @if (skjema.deaktivert) {
                                <button mat-stroked-button type="button" (click)="aktiver(skjema)" data-testid="aktiver-knapp">{{ 'Aktiver' | translate }}</button>
                            } @else {
                                <button mat-stroked-button type="button" (click)="deaktiver(skjema)"
                                        [matTooltip]="'Skjemaet kan da ikke benyttes i nye undersøkelser, eksisterende undersøkelser påvirkes ikke' | translate"
                                        data-testid="deaktiver-knapp">{{ 'Deaktiver' | translate }}</button>
                            }
                            <span [matTooltip]="erIBruk(skjema) ? ('Skjemaet er i bruk og kan ikke slettes' | translate) : ''">
                                <button mat-stroked-button type="button" class="advarsel" [disabled]="erIBruk(skjema)"
                                        [bekreftKlikk]="'Ja, slett skjemaet' | translate" (klikk)="slett(skjema)" data-testid="slett-knapp">
                                    {{ 'Slett' | translate }}
                                </button>
                            </span>
                        </div>
                    </div>
                    @if (erEkspandert(skjema)) {
                        <spoerreskjema-forhaandsvisning class="forhaandsvisning" [skjema]="skjema"/>
                    }
                </article>
            } @empty {
                <div>{{ 'Ingen spørreskjemaer' | translate }}</div>
            }
        </div>
    }
</administrasjon-navigasjon>
